module.exports = __webpack_public_path__ + "img/tatargurkenrollvogel.edb34f49.png";